import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import url from "../../config/axios";
import { useState } from "react";
import { useSelector } from "react-redux";
import { SuccessNotify,FailedNotify } from "../../constants/tostify";
import { useLocation } from "react-router-dom";
const Reportreplymodal = ({ handleClosereport, replyshow,reportM,shopid}) => {
 
 const { name } = useSelector((state) => state.user);
  const location = useLocation();
  const [reportreply, setReportreply] = useState({
    ownerId: name?._id,
    message: "",
  }); 

 const replyHandler=()=>{
  const endpoint =
  location.pathname === `/service-report/${shopid}`
    ? `reportservice/replyfromowner/?serviceId=${shopid}&reportId=${reportM}`
    : `reportshop/replyfromowner/?shopId=${shopid}&reportId=${reportM}`;

    url.put(endpoint,reportreply).then((res)=>{
        console.log("takecare", res);
       
        if(res?.status===200){
            SuccessNotify("Reply Send Successfully")
            handleClosereport();
        }

    }).catch((e)=>{
        FailedNotify("Failed to send Try Again!");
        handleClosereport();
    })
}

  return (
    <>
      <Modal show={replyshow} onHide={handleClosereport}>
        <Modal.Header closeButton className="bg-blue text-white pt-1 pb-1 ">
          <Modal.Title>Report Reply</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            
            <Form.Group
              className="mb-3"
              controlId="exampleForm.ControlTextarea1"
              name="message"
              onChange={(e) => setReportreply({ ...reportreply, message: e.target.value })}
            >

              <Form.Label>Reply</Form.Label>
              <Form.Control as="textarea" rows={3} />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="danger"
            className="pt-0 pb-0 font_13 text-white"
            onClick={handleClosereport}
          >
            Close
          </Button>
          <Button variant="primary" className="pt-0 pb-0 font_14 text-white" onClick={replyHandler}>
            Send
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Reportreplymodal;
